// Actions
import { ActionType } from "@ms/planner-actions/lib/local/ActionType";
/** A tuple of the supported ActionType values for PlanStore, for use in the registry */ export const PlanStoreActionTypes = [
    ActionType.FetchEntityAction,
    ActionType.FetchEntityFailedAction,
    ActionType.FetchEntitySucceededAction,
    ActionType.FetchEntityCollectionAction,
    ActionType.FetchEntityCollectionFailedAction,
    ActionType.FetchEntityCollectionSucceededAction,
    ActionType.FetchAllPlansForContainerTypeAction,
    ActionType.FetchAllPlansForContainerTypeFailedAction,
    ActionType.FetchAllPlansForContainerTypeSucceededAction,
    ActionType.CreateEntityAction,
    ActionType.CreateEntityFailedAction,
    ActionType.CreateEntitySucceededAction,
    ActionType.DeleteEntityAction,
    ActionType.DeleteEntityFailedAction,
    ActionType.DeleteEntitySucceededAction,
    ActionType.DeltaSyncAction,
    ActionType.DeltaSyncSucceededAction,
    ActionType.DeltaSyncFailedAction,
    ActionType.UpdateEntityAction,
    ActionType.UpdateEntityFailedAction,
    ActionType.UpdateEntitySucceededAction,
    ActionType.SetDefaultPlanAction,
    ActionType.SetFlaggedEmailPlanAction,
    ActionType.MovePlanOperationAction,
    ActionType.MovePlanOperationCompletedAction,
    ActionType.MovePlanOperationCompletedWithErrorsAction,
    ActionType.ResetMovePlanOperationAction,
    ActionType.SetPlanFilterAction,
    ActionType.SetRecommendedPlansAction,
    ActionType.RemovePlanFromRecommendedListAction,
    ActionType.CreatePlanFromTemplateAction,
    ActionType.CreatePlanFromTemplateSucceededAction,
    ActionType.CreatePlanFromTemplateFailedAction,
    ActionType.CreatePlanFromTemplateResetAction
];
